import { Head, router } from "@inertiajs/react"
import { BellOff, CheckCircle2, XCircle } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import { unsubscribeNotificationPath } from "@/routes"

interface Props {
  kind: "alerts" | "deliveries" | null
  token?: string
  done?: boolean
}

const KIND_LABELS = {
  alerts: "alert emails",
  deliveries: "delivery notifications",
}

const invalidState = (
  <>
    <XCircle className="text-muted-foreground mb-4 h-12 w-12" />
    <h1 className="mb-2 text-2xl font-semibold">Link not found</h1>
    <p className="text-muted-foreground">
      This unsubscribe link is invalid or the notification preference it
      referred to has been removed.
    </p>
  </>
)

// GET renders this confirmation; the actual flip is the POST below so that
// mail-scanner link prefetches can never silently unsubscribe anyone.
export default function Unsubscribed({ kind, token, done }: Props) {
  const [submitting, setSubmitting] = useState(false)

  return (
    <>
      <Head title="Unsubscribe" />
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6 text-center">
        {!kind ? (
          invalidState
        ) : done ? (
          <>
            <CheckCircle2 className="mb-4 h-12 w-12 text-green-600" />
            <h1 className="mb-2 text-2xl font-semibold">
              You&apos;re unsubscribed
            </h1>
            <p className="text-muted-foreground">
              You&apos;ll no longer receive {KIND_LABELS[kind]} for this
              facility. You can turn them back on anytime in Rebulk.
            </p>
          </>
        ) : token ? (
          <>
            <BellOff className="text-muted-foreground mb-4 h-12 w-12" />
            <h1 className="mb-2 text-2xl font-semibold">
              Unsubscribe from {KIND_LABELS[kind]}?
            </h1>
            <p className="text-muted-foreground">
              You&apos;ll stop receiving {KIND_LABELS[kind]} for this facility.
              You can turn them back on anytime in Rebulk.
            </p>
            <Button
              className="mt-6"
              disabled={submitting}
              onClick={() =>
                router.post(
                  unsubscribeNotificationPath(kind, token),
                  {},
                  {
                    onStart: () => setSubmitting(true),
                    onFinish: () => setSubmitting(false),
                  },
                )
              }
            >
              Unsubscribe
            </Button>
          </>
        ) : (
          invalidState
        )}
      </div>
    </>
  )
}
